const SUPPORT_TOUCH = ('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0)

const CUSTOM_STYLE_ELMT = (doc => {
    const styleElmt = doc.createElement('style')
    styleElmt.type = 'text/css'
    doc.head.appendChild(styleElmt)
    return styleElmt
})(document)

function addCss( str )
{
    const styleElmt = CUSTOM_STYLE_ELMT
    if (styleElmt.styleSheet)
    {
        styleElmt.styleSheet.cssText += str
    }
    else
    {
        styleElmt.appendChild(document.createTextNode(str))
    }
}

export default {

    data() {
        return {
            touch: SUPPORT_TOUCH
        }
    },

    created()
    {
        this._letters = []
    },

    props: {
        showMenu: { type: Boolean, default: false },
        isOpen: { type: Boolean, default: false }
    },

    mounted()
    {
        const textAnimElmts = [...this.$el.querySelectorAll('.js-text-anim')]

        let id = 0
        for (const elmt of textAnimElmts)
        {
            this._splitText(elmt, id)
            id++
        }

        this._initCss(textAnimElmts)
    },

    methods: {

        _close()
        {
            this.$root.$children[0].toggleMenu()
        },

        _splitText( elmt, id )
        {
            const txt = elmt.innerText
            const words = txt.split(' ')

            let newTxt = ''
            const multipleWords = words.length > 1
            for(let i = 0; i < words.length; i++)
            {
                const word = words[i]
                if (multipleWords)
                {
                    newTxt += '<span class="u-inline-block">'
                }

                const letters = word.split('')
                for(const letter of letters)
                {
                    newTxt += `<span class="u-inline-block is-letter">${letter}</span>`
                }

                if (multipleWords)
                {
                    newTxt += (i < (words.length - 1) ? '&nbsp;' : '') + '</span>'
                }
            }

            elmt.innerHTML = newTxt
        },

        _initCss( listLinks )
        {
            addCss(`.c-letter__letter-bg { color: #97BB93; }`)

            const blackScreenTime = 1

            let lineId = 0
            for (const linkElmt of listLinks)
            {
                const listLetters = [...linkElmt.querySelectorAll('.is-letter')]

                let letterId = 0
                for (const letterElmt of listLetters)
                {
                    const className = 'js-menu-letter-anim-' + lineId + '-' + letterId

                    const inTime = (lineId * 0.05 + letterId * 0.04 + 0.6 + blackScreenTime).toFixed(2) + 's'
                    const inTimeOpacity = (lineId * 0.05 + letterId * 0.02 + 0.8 + blackScreenTime).toFixed(2) + 's'
                    const inTimeBlack = (lineId * 0.05 + (5 - letterId) * 0.02 + 1.1 + blackScreenTime).toFixed(2) + 's'
                    const outTime = (lineId * 0.01).toFixed(2) + 's'

                    addCss(`.c-menu-anim-enter-active .is-letter.${className} { transition-delay: ${inTime}, ${inTimeOpacity}; }`)

                    addCss(`.c-menu-anim-leave-active .is-letter.${className} { transition-delay: ${outTime}, ${outTime}; }`)

                    addCss(`.c-menu-anim-enter-active .is-letter.${className} .is-letter__black { transition-delay: ${inTimeBlack}; }`)

                    letterElmt.classList.add(className)
                    letterElmt.classList.add('u-relative')

                    const letterStr = letterElmt.innerHTML

                    letterElmt.innerHTML = ''
                    const letterBg = document.createElement('span')
                    const letterOver = document.createElement('span')
                    letterBg.classList.add('u-absolute')
                    letterBg.classList.add('u-pos-tl')
                    letterBg.classList.add('u-block')
                    letterBg.classList.add('c-letter__letter-bg')
                    letterOver.classList.add('u-relative')
                    letterOver.classList.add('is-letter__black')
                    letterOver.classList.add('u-block')

                    letterBg.innerHTML = letterStr
                    letterOver.innerHTML = letterStr

                    letterElmt.appendChild(letterBg)
                    letterElmt.appendChild(letterOver)

                    letterId++
                }

                lineId++
            }
        },

        _initLinks( elmt, linkId )
        {
            const list = [...this.$el.querySelectorAll('.js-letter-anim')]
            const letterList = []

            let letterId = 0
            for (const letter of list)
            {
                letterList[letterId] = letter
                this._setDelayIn( letter, linkId, letterId )
                letterId++
            }

            this._letters[linkId] = letterList
        },

        _setDelayIn( elmt, linkId, letterId )
        {
            const style = elmt.style
            const time = (linkId * 0.1 + letterId * 0.01) + 's'
            style.transitionDelay = time + ', ' + time
        },

        _setDelayOut( elmt, linkId )
        {
            const style = elmt.style
            style.transitionDelay = (linkId * 0.1) + 's'
        }
    }
}
